import { render, staticRenderFns } from "./UploadedFileProjectsModal.vue?vue&type=template&id=c67e9a9e&scoped=true"
import script from "./UploadedFileProjectsModal.vue?vue&type=script&lang=js"
export * from "./UploadedFileProjectsModal.vue?vue&type=script&lang=js"
import style0 from "./UploadedFileProjectsModal.vue?vue&type=style&index=0&id=c67e9a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67e9a9e",
  null
  
)

export default component.exports